import React, { Component } from "react";
import withRouter from "helpers/withRouter";
import UserAPIGateway from "accounts/gateways/user";

class JobTrackIframeEmbed extends Component {
  state = {
    src: null,
    loading: true,
  };


  handleIframeMessage = (event) => {
    const allowedOrigin = process.env.REACT_APP_JOBTRAKS_BASE_URL;

    if (!allowedOrigin.startsWith(event.origin)) {
      console.warn(`Blocked message from unauthorized origin: ${event.origin}`);
      return;
    }

    const { type, data } = event.data;
    console.log(data, "data")
    if (typeof type !== "string") return;
    if (type.startsWith("COLUMN_CLICK_EVENT_")) {
      const match = type.match(/^COLUMN_CLICK_EVENT_(\d+)_(.+)$/);
      if (!match || !data) return;
      const { employee: employeeId, job_id: jobId } = data;
      if (employeeId) {
        this.props.navigate(`/employee/${employeeId}/edit/employeeWagesAndCost?empName=${data.name}&empWage=${data.wage}&empId=${employeeId}`);
      } else if (jobId) {
        this.props.navigate(`/job/list/${jobId}/edit`);
      }
      return;
    }
    if (type.startsWith("EMITTER_PANEL_PERMISSION_")) {
      const match = type.match(/^EMITTER_PANEL_PERMISSION_(\d+)_(.+)$/);
      if (!match || !data) return;

      const buttonType = data?.name;

      const routes = {
        "Employees": "/employee/add",
        "Jobs": "/job/list/add",
        "Route Name": `/jobTrack/routes/list/360?route_id=${data.route_id}`
      };

      if (buttonType && routes[buttonType]) {
        this.props.navigate(routes[buttonType]);
      }

      if (data?.id) {
        this.props.navigate('/employee/add');
      }
    }
  };


  async componentDidMount() {
    await this.ensureValidTokenAndSetSrc();
    window.addEventListener("message", this.handleIframeMessage);
  }

  componentDidUpdate(prevProps) {
    // Re-check if src changes (e.g., key or type changes)
    if (prevProps.key !== this.props.key || prevProps.type !== this.props.type) {
      this.ensureValidTokenAndSetSrc();
    }
  }


  componentWillUnmount() {
    window.removeEventListener("message", this.handleIframeMessage);
  }





  // Use predefined API function instead of hardcoding fetch
  fetchNewToken = async () => {
    try {
      const apiGateway = new UserAPIGateway();
      const tokenResponse = await apiGateway.getJobTrackToken();
      return tokenResponse;
    } catch (error) {
      return null;
    }
  };

  // Ensure token is valid, refresh if expired
  ensureValidTokenAndSetSrc = async () => {
    const loginTimestamp = localStorage.getItem("loginTimestamp");
    const now = Date.now();
    const expiryTime = localStorage.getItem("iframe_jwt_token") * 1000; // convert seconds to ms

    let JobTrackAuthToken = localStorage.getItem("JobTrackBearerToken");
    let refreshToken = localStorage.getItem("jobTrackRefreshToken");
    let jwtToken = localStorage.getItem("iframe_jwt_token");
    let orgId = localStorage.getItem("jobTrackOrgId");
    let tokenExpiry = localStorage.getItem("iframe_jwt_token_expiry")

    if (!loginTimestamp || now - loginTimestamp > expiryTime) {

      const tokenResponse = await this.fetchNewToken();
      if (tokenResponse) {
        JobTrackAuthToken = tokenResponse.access_token;
        jwtToken = tokenResponse.jwt_token;
        refreshToken = tokenResponse.refresh_token;
        tokenExpiry = tokenResponse.jwt_token_expiry || 3600

        // Keep old orgId, do not overwrite
        const oldOrgId = localStorage.getItem("jobTrackOrgId");
        orgId = oldOrgId;
        if (!orgId) {

          return;
        }

        // Update tokens in localStorage
        localStorage.setItem("JobTrackBearerToken", JobTrackAuthToken);
        localStorage.setItem("jobTrackRefreshToken", refreshToken);
        localStorage.setItem("iframe_jwt_token", jwtToken);
        localStorage.setItem("loginTimestamp", now);
        localStorage.setItem("iframe_jwt_token_expiry", 3600)


      }
    }

    if (JobTrackAuthToken && jwtToken && orgId) {
      // Build iframe URL dynamically
      const { src: originalSrc } = this.props;
      const url = new URL(originalSrc);

      url.searchParams.set("access_token", JobTrackAuthToken);
      url.searchParams.set("refresh_token", refreshToken);
      url.searchParams.set("jwt_token", jwtToken);
      url.searchParams.set("orgId", orgId);
      url.searchParams.set("jwt_expiry", tokenExpiry);
      url.searchParams.set("embed", "true");

      this.setState({ src: url.toString(), loading: false });

    } else {

      this.setState({ loading: true });
    }
  };

  render() {
    const { type, key } = this.props;
    const { src, loading } = this.state

    if (loading) return <div>Loading...</div>;

    return (
      <iframe
        key={key}
        title="component-preview"
        width="100%"
        src={src}
        style={{
          border: "none",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: type ? "67%" : "100%",
          marginTop: type && "14rem",
        }}
        allowFullScreen
      />
    );
  }
}

export default withRouter(JobTrackIframeEmbed);
